/**
 * Use to execute code only after page is loaded.
 * This can be used to decrease initial loading time.
 *
 * @returns {Promise}
 */
export function onLoad() {
  return new Promise(resolve => {
    document.readyState === 'complete' ? resolve() : window.addEventListener('load', resolve())
  })
}
